import type { Status } from '../../../types';
import { StatusBadge } from '../../base';

const StatusRenderer = (status: Status) => <StatusBadge sx={{ display: 'block' }} status={status} />;

export default StatusRenderer;
